import { apiService } from "./api";
import { PaymentMethod, OrderItem } from "../types";

export type ReturnCondition = "RESELLABLE" | "DAMAGED";

export interface OrderReturnItem {
    return_item_id: string;
    return_id: string;
    order_item_id: string;
    quantity: number;
    condition: ReturnCondition;
    unit_price: number;
    unit_cost_price: number;
    revenue_reversed: number;
    cost_reversed: number;
    order_item?: OrderItem;
    create_time: string;
    update_time: string;
}

export interface OrderReturn {
    return_id: string;
    return_number: string;
    order_id: string;
    status: string;
    reason: string;
    return_date: string;
    notes?: string;
    total_revenue_reversed: number;
    total_cost_reversed: number;
    refund_amount: number;
    created_by_user_id?: string;
    items: OrderReturnItem[];
    create_time: string;
    update_time: string;
}

export interface CreateReturnItemRequest {
    order_item_id: string;
    quantity: number;
    condition: ReturnCondition;
}

export interface CreateReturnRequest {
    items: CreateReturnItemRequest[];
    reason: string;
    notes?: string;
    refund_amount: number;
    refund_payment_method?: PaymentMethod;
    refund_reference_number?: string;
    refund_account_id?: string | null;
}

class OrderReturnService {
    async getReturns(orderId: string): Promise<OrderReturn[]> {
        return apiService.get<OrderReturn[]>(`/orders/${orderId}/returns`);
    }

    async createReturn(orderId: string, data: CreateReturnRequest): Promise<OrderReturn> {
        return apiService.post<OrderReturn>(`/orders/${orderId}/returns`, data);
    }
}

export const orderReturnService = new OrderReturnService();
